import type { TOptions } from 'i18next';
import type { ReactNode } from 'react';

import { showErrorMessage, showSuccessMessage, showWarningMessage } from 'src/shared/utils/messages';

import type { I18NextStore } from '../i18next/i18next-store';

export class NotificationsStore {
  private readonly i18: I18NextStore;

  showErrorMessage: (value: ReactNode, options?: { duration?: number; key?: number }) => void;
  showSuccessMessage: (value: string) => void;
  showWarningMessage: (value: string) => void;

  constructor(i18: I18NextStore) {
    this.showErrorMessage = showErrorMessage;
    this.showSuccessMessage = showSuccessMessage;
    this.showWarningMessage = showWarningMessage;

    this.i18 = i18;
  }

  showErrorMessageT(text: string, options?: TOptions & { duration?: number; key?: number }): void {
    const { duration, key, ...rest } = options ?? {};
    const message = this.i18.t(text, rest);

    this.showErrorMessage(message, { duration, key });
  }

  showWarningMessageT(text: string, options?: TOptions): void {
    const message = this.i18.t(text, options);

    this.showWarningMessage(message);
  }

  showSuccessMessageT(text: string, options?: TOptions): void {
    const message = this.i18.t(text, options);

    this.showSuccessMessage(message);
  }
}
